module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_8017.2e12b876.png";